import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store'

// Auth
import LoginPage from '../pages/auth/LoginPage'
// import RegisterPage from '../pages/auth/RegisterPage'
import EmailResetPage from '../pages/auth/EmailResetPage'
import ResetPasswordPage from '../pages/auth/ResetPasswordPage'

// Admin
import LayoutAdmin from '../pages/layouts/LayoutAdmin'
import HomePage from '../pages/HomePage'

// Users
import ListaUsers from '../pages/users/index'
import FormUsers from '../pages/users/form'
import ShowUsers from '../pages/users/show'

// Buildings
import ListaBuildings from '../pages/buildings/index'
import FormBuildings from '../pages/buildings/form'
import ListDepartments from '../pages/departments/index'

import ContractsBis from '../pages/contracts_bis/index'
import Contracts from '../pages/contracts/index'
import ServicesContract from '../pages/contracts_services/index'
import Debts from '../pages/debts/index'
import DebtsReport from '../pages/debts_reports/index'
import DebtsListReport from '../pages/debts_list_report/index'
import DebtsListReportMonth from '../pages/debts_list_report_month/index'

// Concepts
import ListaConcepts from '../pages/concepts/index'
import FormConcepts from '../pages/concepts/form'

// Rules
import ListaRules from '../pages/rules/index'

// BankAccounts
import ListaBankAccounts from '../pages/bank_accounts/index'

// Companies
import ListaCompanies from '../pages/companies/index'
import FormCompanies from '../pages/companies/form'

// Permissions
import ListaPermissions from '../pages/permissions/index'
import FormPermissions from '../pages/permissions/form'

// Bill
import ListaBill from '../pages/bill/index'

// BillVault
import ListaBillVault from '../pages/vault/index'

// BillDownloads
import ListaBillDownLoads from '../pages/bill_download/index'

// BillUploads
import ListaBillUploads from '../pages/bill_upload/index'

// PayRoll
import ListaPayRoll from '../pages/payroll/index'
import ListaPaysPayroll from '../pages/payroll/pay'

// Partners
import ListaShares from '../pages/partner/index'
import ListaAdvances from '../pages/partner/advances'
import ListaPaysShares from '../pages/partner/pay'

import INPC from '../pages/inpc/index'

// Tax
import ListaTax from '../pages/tax/index'
import ListaPayTax from '../pages/pays_tax/index'

// Buy
import FormBuy from '../pages/buy/form'
import ListaBuy from '../pages/buy/index'
import ReportBuy from '../pages/buy_report/index'

// budgets
import FormBudgets from '../pages/budgets/form'
import ListaBudgets from '../pages/budgets/index'

// incomes
import ListaIncomes from '../pages/incomes/index'

// pays
import ListaPays from '../pages/pays/index'
import ListaPaysPaid from '../pages/pays_ paid/index'
import ListaIncomePaid from '../pages/income_paid/index'

// Checks
import ListaChecks from '../pages/checks/index'

//Caja chica
import ListaPettyCash from '../pages/petty_cash/index'

// Depositos
import ListaDeposits from '../pages/deposits/index'

// Statements Accounts
import ListaStatementsAccounts from '../pages/statement_account/index'

// Invoices Issued
import ListaInvoicesIssued from '../pages/invoices_issued/index'

// Checkbook
import ListaCheckbook from '../pages/checkbook/index'

// Rules Billing
import ListaRulesBilling from '../pages/rules_billing/index'

import Profile from '../pages/users/profile'
import Report from '../pages/report/index'

// Vacations
import ListaVacations from '../pages/vacations/index'

// Programs
import ListaPrograms from '../pages/programs/index'

// Programs Investors
import ListaProgramsInvestors from '../pages/programs_investors/index'

// Banking Services
import ListaBankingServicesRules from '../pages/banking_services/index'

// Banking Services Payments
import ListaBankingServices from '../pages/banking_service_payments/index'

Vue.use(VueRouter);

export const router = new VueRouter({
	// mode: 'history',
	mode: 'hash',
	routes: [
		// { path: '/', component: HomePage },
		{ path: '/login', component: LoginPage, name: 'login' },
		// { path: '/register', component: RegisterPage, name: 'register' },
		{ path: '/password-reset', component: EmailResetPage, name: 'password-reset' },
		{ path: '/change-password', component: ResetPasswordPage, name: 'change-password' },
		{
			path: '/',
			name: 'app',
			component: LayoutAdmin,
			children: [
				{
					path: '/',
					name: 'app-home',
					component: HomePage,
				},
				// Profile
				{
					path: '/profile',
					name: 'profile',
					component: Profile,
				},
				// Users
				{
					path: '/users',
					name: 'users',
					component: ListaUsers,
				},
				{
					path: '/users/form',
					name: 'add_users',
					component: FormUsers,
				},
				{
					path: '/users/form/:id',
					name: 'edit_users',
					component: FormUsers,
				},
				{
					path: '/users/show/:id',
					name: 'show_users',
					component: ShowUsers,
				},
				// buildings 
				{
					path: '/buildings',
					name: 'buildings',
					component: ListaBuildings,
				},
				{
					path: '/buildings/form',
					name: 'add_buildings',
					component: FormBuildings,
				},
				{
					path: '/buildings/form/:id',
					name: 'edit_buildings',
					component: FormBuildings,
				},
				// Concepts 
				{
					path: '/concepts',
					name: 'concepts',
					component: ListaConcepts,
				},
				{
					path: '/concepts/form',
					name: 'add_concepts',
					component: FormConcepts,
				},
				{
					path: '/concepts/form/:id',
					name: 'edit_concepts',
					component: FormConcepts,
				},
				// Rules 
				{
					path: '/rules',
					name: 'rules',
					component: ListaRules,
				},
				// Rules 
				{
					path: '/bank_accounts',
					name: 'bank_accounts',
					component: ListaBankAccounts,
				},
				// Companies 
				{
					path: '/companies',
					name: 'companies',
					component: ListaCompanies,
				},
				{
					path: '/companies/form',
					name: 'add_companies',
					component: FormCompanies,
				},
				{
					path: '/companies/form/:id',
					name: 'edit_companies',
					component: FormCompanies,
				},
				// Permisos
				{
					path: '/permissions',
					name: 'permissions',
					component: ListaPermissions,
				},
				{
					path: '/permissions/form/:id?',
					name: 'edit_permissions',
					component: FormPermissions,
				},
				// Bill
				{
					path: '/bill',
					name: 'bill',
					component: ListaBill,
				},
				// Vault
				{
					path: '/vault',
					name: 'vault',
					component: ListaBillVault,
				},
				// Payroll
				{
					path: '/payroll',
					name: 'payroll',
					component: ListaPayRoll,
				},
				{
					path: '/pay_payroll',
					name: 'pay_payroll',
					component: ListaPaysPayroll,
				},
				// Partners
				{
					path: '/partners',
					name: 'partners',
					component: ListaShares,
				},
				{
					path: '/advances',
					name: 'advances',
					component: ListaAdvances,
				},
				{
					path: '/pay_share',
					name: 'pay_share',
					component: ListaPaysShares,
				},
				// DownloadBills
				{
					path: '/bill_download',
					name: 'bill',
					component: ListaBillDownLoads,
				},
				// UploadBills
				{
					path: '/bill_upload',
					name: 'bill',
					component: ListaBillUploads,
				},
				// Tax
				{
					path: '/tax',
					name: 'tax',
					component: ListaTax,
				},
				{
					path: '/pays_tax',
					name: 'pays_tax',
					component: ListaPayTax,
				},
				// budgets 
				{
					path: '/budgets',
					name: 'budgets',
					component: ListaBudgets,
				},
				{
					path: '/budgets/form',
					name: 'add_budgets',
					component: FormBudgets,
				},
				{
					path: '/budgets/form/:id',
					name: 'edit_budgets',
					component: FormBudgets,
				},
				// Buy 
				{
					path: '/buy',
					name: 'buy',
					component: ListaBuy,
				},
				{
					path: '/report',
					name: 'report',
					component: ListaBuy,
				},
				{
					path: '/report_buy',
					name: 'report_buy',
					component: ReportBuy,
				},
				{
					path: '/buy/form/:id',
					name: 'edit_buy',
					component: FormBuy,
				},
				// checks 
				{
					path: '/checks',
					name: 'checks',
					component: ListaChecks,
				},
				// pays 
				{
					path: '/pays',
					name: 'pays',
					component: ListaPays,
				},
				{
					path: '/pays_paid',
					name: 'pays_paid',
					component: ListaPaysPaid,
				},
				{
					path: '/income_paid',
					name: 'income_paid',
					component: ListaIncomePaid,
				},
				// ListaIncomes 
				{
					path: '/incomes',
					name: 'incomes',
					component: ListaIncomes,
				},
				// Reporte 
				{
					path: '/report',
					name: 'report',
					component: Report,
				},
				// Contratos 
				{
					path: '/contracts',
					name: 'contracts',
					component: Contracts,
				},
				{
					path: '/contracts_bis',
					name: 'contracts_bis',
					component: ContractsBis,
				},
				// Contracts Services
				{
					path: '/service_contracts',
					name: 'service_contracts',
					component: ServicesContract,
				},
				// Adeudos 
				{
					path: '/debts',
					name: 'debts',
					component: Debts,
				},
				{
					path: '/debts_reports',
					name: 'debts_reports',
					component: DebtsReport,
				},
				{
					path: '/debts_list_report',
					name: 'debts_list_report',
					component: DebtsListReport,
				},
				{
					path: '/debts_list_report_month',
					name: 'debts_list_report_month',
					component: DebtsListReportMonth,
				},
				// Caja Chica 
				{
					path: '/petty_cash',
					name: 'petty_cash',
					component: ListaPettyCash,
				},
				// Depositos
				{
					path: '/deposits',
					name: 'deposits',
					component: ListaDeposits,
				},
				// Statements Accounts
				{
					path: '/statements_accounts',
					name: 'statements_accounts',
					component: ListaStatementsAccounts,
				},
				// Departments
				{
					path: '/departments',
					name: 'departments',
					component: ListDepartments,
				},
				// Invoices Issued
				{
					path: '/invoices_issued',
					name: 'invoices_issued',
					component: ListaInvoicesIssued,
				},
				// Checkbook
				{
					path: '/checkbook',
					name: 'checkbook',
					component: ListaCheckbook,
				},
				// INPC
				{
					path: '/inpc',
					name: 'inpc',
					component: INPC,
				},
				// Rules Billing
				{
					path: '/rules_billing',
					name: 'rules_billing',
					component: ListaRulesBilling,
				},
				// Vacations
				{
					path: '/vacations',
					name: 'vacations',
					component: ListaVacations,
				},
				// Programs
				{
					path: '/programs',
					name: 'programs',
					component: ListaPrograms,
				},
				// Programs Investors
				{
					path: '/programs_investors/:id',
					name: 'programs_investors',
					component: ListaProgramsInvestors,
				},
				// Banking Services
				{
					path: '/banking_services_rules',
					name: 'banking_services_rules',
					component: ListaBankingServicesRules,
				},
				// Banking Services
				{
					path: '/banking_services',
					name: 'banking_services',
					component: ListaBankingServices,
				},
			]
		},
		// otherwise redirect to home
		{ path: '*', redirect: '/' }
	]
});

router.beforeEach((to, from, next) => {

	// Cargador de pagina
	if (to.name != from.name) {
		store.state.status.routeChange = true;
	}

	// Accesos publicos
	const publicPages = ['/login', '/register', '/password-reset', '/change-password'];
	const authRequired = !publicPages.includes(to.path);


	// Verificamos si esta logueado
	const loggedIn = JSON.parse(localStorage.getItem('user'));
	let permissions = null;
	if (loggedIn) {
		permissions = loggedIn.profile ? loggedIn.profile.permissions : [];
	}

	const publicPagesLogin = ['/profile','/vault'];
	const authRequiredAuth = publicPagesLogin.includes(to.path);

	// console.log(authRequiredAuth);
	// console.log(to.path);



	// Redirige a home si se loguea
	if (loggedIn && !authRequired) {
		return next('/');
	}

	if (authRequiredAuth && loggedIn) {
		return next();
	}

	// Validamos permisos se usuario
	if (permissions) {
		if (to.fullPath != '/') {
			let res = permissions.findIndex(s => s.permission === to.name);
			if (res == -1) {
				return next('/');
			} else {
				next();
			}
		}
	}

	// Redirige a login si no esta logueado
	if (authRequired && !loggedIn) {
		return next('/login');
	}

	next();
});

router.afterEach((to, from) => {
	// Cargador de pagina
	if (to.name != from.name) {
		setTimeout(() => {
			store.state.status.routeChange = false;
		}, 1000);
	}

})


export default router
